import {combineReducers} from '@reduxjs/toolkit';
import {persistReducer} from 'redux-persist';
import {persistConfig} from './persistConfig';
import {emptyApi as api} from './generated/api';
import updatesReducer from './updatesSlice';
import translationToggleReducer from './slices/translationToggleSlice';
import currencyReducer from './currencySlice';

const appReducer = combineReducers({
    [api.reducerPath]: api.reducer,
    updates: updatesReducer,
    translationToggle: translationToggleReducer,
    currency: currencyReducer,
});

const rootReducer = (state: any, action: any) => {
    return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;